export default "__VITE_ASSET__fkXuehdp__"